import { useFn } from '@eturi/react'
import { useContext, useLayoutEffect } from 'react'
import { ResponsiveContext } from './ResponsiveContext'
import type { ResponsiveCtx } from './types'

export const useResponsiveEffect = (fn: (ctx: ResponsiveCtx) => void | (() => void)) => {
	const ctx = useContext(ResponsiveContext)
	const immutableFn = useFn(fn)

	useLayoutEffect(() => immutableFn(ctx), [ctx])
}
